import { render, staticRenderFns } from "./SearchResultThird.vue?vue&type=template&id=d2af89be&"
import script from "./SearchResultThird.vue?vue&type=script&lang=js&"
export * from "./SearchResultThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports